export default __webpack_public_path__ + "static/media/logoNVIDIA_2.2ccf9aab.png";